import React, { useEffect } from "react";
import TransactionRow from "../TransactionRow/TransactionRow";
import Preloader from "../../../components/UI/Preloader/Preloader";
import classes from "./TransactionTable.module.sass";

import useMakeRequest from "../../../hooks/useMakeRequest";

function TransactionTable() {
  const [setParams, result, isLoading, hasError, error] = useMakeRequest();

  useEffect(() => {
    setParams({
      c: "accountStore",
      a: "transactionData",
    });
  }, []);

  if (hasError && error) {
    throw new Error(error);
  }

  return (
    <>
      {isLoading && !result && <Preloader />}
      {result && !hasError && !isLoading && (
        <div className={classes.transactionTable_wrap}>
          <div className={classes.transactionTable_wrap}>
            <table className={classes.transactionTable}>
              <thead>
                <tr>
                  <th>Order #</th>
                  <th className={classes.transactionTable_description}>
                    Description
                  </th>
                  <th>Type</th>
                  <th>status</th>
                  <th>Billing Date</th>
                  <th>Amount</th>
                  <th aria-label="Invoice" />
                </tr>
              </thead>
              <tbody>
                {result.map((transaction, id) => {
                  return (
                    <TransactionRow
                      key={id}
                      transactionId={transaction.transaction_id}
                      name={transaction.item_name}
                      type={transaction.type}
                      status={transaction.state}
                      date={transaction.created_time}
                      amount={transaction.amount}
                      returns={transaction.returns}
                      localAmount={transaction.local_amount}
                      localCurrency={transaction.local_currency}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default TransactionTable;
